var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"widget-link -pxy_0"},[_c('div',[_c('sword-icon-wuk',{attrs:{"name":_vm.icon}})],1),_c('p',{staticClass:"t4 -t_medium -mt_1 -mb_0 mt5 compact-text"},[_vm._v(" "+_vm._s(_vm.$t(_vm.label))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }